<template>
    <div class="pay-container">
      <p class="pay-text">正在准备支付...</p>
      <div v-html="payHtml"></div>
    </div>
</template>

<script>
  export default {
    name: 'pay',
    data() {
      return {
        payHtml: ''
      }
    },
    created() {
      this.toAliPay()
    },
    methods: {
      toAliPay() {
        const _this = this
        const orderNo = this.$route.query.orderNo
        if (!orderNo || orderNo == '') {
          return
        }
        _this.ajpost('/api/order/preparePay?orderNo=' + orderNo, {}, function (payData) {
          _this.payHtml = payData.data.data
          setTimeout(() => {
            document.forms[0].submit();
          }, 1000)
        },function (err) {
          console.log(err)
        });
      }
    }
  }
</script>

<style scoped>
.pay-container{min-height: 50vh;}
.pay-text{font-size: 16px;margin: 16px;}
</style>



// WEBPACK FOOTER //
// src/components/pay/pay.vue